import React, { useState, useEffect } from "react";
import { toast, ToastOptions } from "react-toastify";

const originalToastError = toast.error;
// Save original methods
const originalToastSuccess = toast.success;
const originalToastInfo = toast.info;
const originalToastWarning = toast.warning;

const autoCloseDefault = 8000;
const customOptions = {
  autoClose: autoCloseDefault, // Default duration
  pauseOnHover: true,
  containerId:"globalID",
  closeOnClick: false,
  pauseOnFocusLoss:false
};

export const CustomToastError = (
  message: string,
  options: ToastOptions = {}
): React.ReactText  => {

  return originalToastError(
    <div
      className="custom-toast"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span style={{ flex: 1, marginRight: "10px" }}>{message}</span>
      <button
        className="border-0 copy-btn"
        onClick={(e) => {
          const button = e.target as HTMLButtonElement;
          navigator.clipboard.writeText(message); // Copy to clipboard

          const toastContainer:any = button.closest(".custom-toast");
          const copiedText = document.createElement("span");
          copiedText.className = "copied-text slide-in";
          copiedText.innerText = "Copied";
          toastContainer.appendChild(copiedText);

          setTimeout(() => {
            copiedText.classList.add("slide-out");
            copiedText.classList.remove("slide-in");
            setTimeout(() => copiedText.remove(), 2000);
          }, 2000);
        }}
        style={{
          background: "none",
          border: "none",
          color: "black",
          borderRadius: "4px",
          cursor: "pointer",
          padding: "4px 8px",
          fontSize: "12px", 
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
          <path d="M10.3158 0H1.47368C0.659474 0 0 0.650909 0 1.45455V11.6364H1.47368V1.45455H10.3158V0ZM12.5263 2.90909H4.42105C3.60684 2.90909 2.94737 3.56 2.94737 4.36364V14.5455C2.94737 15.3491 3.60684 16 4.42105 16H12.5263C13.3405 16 14 15.3491 14 14.5455V4.36364C14 3.56 13.3405 2.90909 12.5263 2.90909ZM12.5263 14.5455H4.42105V4.36364H12.5263V14.5455Z" fill="#84888C"/>
        </svg>
      </button>
    </div>,
    {
      ...options,
      ...customOptions,
    }
  );
};

// Custom toast implementations
export const CustomToastSuccess = (
  message: string,
  options: ToastOptions = {}
): React.ReactText  => {

  const finalOptions = {
    ...options, // Ensures `options.containerId` is not overwritten
    ...customOptions, 
  };


  return originalToastSuccess(message, finalOptions);
};

export const CustomToastInfo = (
  message: string,
  options: ToastOptions = {}
): React.ReactText => {
  return originalToastInfo(message, {
    ...options,
    ...customOptions,
  });
};

export const CustomToastWarning = (
  message: string,
  options: ToastOptions = {}
): React.ReactText => {
  return originalToastWarning(message, {
    ...options,
    ...customOptions,
  });
};
